import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import HeroSection from './../components/sections/Home/HeroSection/HeroSection';
import ContactForm from './../components/sections/Home/ContactForm/ContactForm';
import ValueProposition from './../components/sections/Home/ValueProposition/ValueProposition';
import ServicesOverview from './../components/sections/Home/ServicesOverview/ServicesOverview';
import ClientCallout from './../components/sections/Home/ClientCallout/ClientCallout';
import HowItWorks from './../components/sections/Home/HowItWorks/HowItWorks';

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToContact) {
      const el = document.getElementById('hubspot-form');
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 500); // Wait for DOM to mount
      }
    }
  }, [location]);
  
  return (
    <>
      <HeroSection />
      <ValueProposition />
      <ServicesOverview />
      <ClientCallout />
      <HowItWorks />
      <ContactForm />
    </>
  );
};

export default HomePage;